export const PURCHASE_MODES = {
    REPASSE: 0,
    COTACAO: 1,
    BID: 2
}